import { useFeatureIsOn as _useFeatureIsOn } from '@growthbook/growthbook-react';

import { AppFeatures } from '../types';

const useFeatureIsOn = (id: keyof AppFeatures & string): boolean =>
  _useFeatureIsOn<AppFeatures>(id);

export default useFeatureIsOn;
